import { formatCurrency } from "./currency";

export const generateOrderNumber = () => {
  const ts = Date.now().toString(36).toUpperCase();
  const rand = Math.random().toString(36).substring(2, 6).toUpperCase();
  return `EP-${ts}-${rand}`;
};

export const maskCardNumber = (cardNumber) => {
  const clean = cardNumber.replace(/\s/g, "");
  return `**** **** **** ${clean.slice(-4)}`;
};

export const createOrder = ({ cartItems, subtotal, formData }) => {
  const orderId = generateOrderNumber();
  const now = new Date();

  return {
    orderId,
    orderDate: now.toISOString(),
    orderDateFormatted: now.toLocaleDateString("en-US", {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    }),
    customer: {
      firstName: formData.firstName,
      lastName: formData.lastName,
      email: formData.email,
      phone: formData.phone,
    },
    shippingAddress: {
      address: formData.shippingAddress,
      city: formData.shippingCity,
      state: formData.shippingState,
      zip: formData.shippingZip,
      country: formData.shippingCountry,
    },
    billing: formData.billingSameAsShipping
      ? {
          address: formData.shippingAddress,
          city: formData.shippingCity,
          state: formData.shippingState,
          zip: formData.shippingZip,
          country: formData.shippingCountry,
        }
      : {
          address: formData.billingAddress,
          city: formData.billingCity,
          state: formData.billingState,
          zip: formData.billingZip,
          country: formData.billingCountry,
        },
    payment: {
      cardholderName: formData.cardholderName,
      maskedCard: maskCardNumber(formData.cardNumber),
      expiry: formData.cardExpiry,
      method: "Credit Card",
    },
    items: cartItems.map((item) => ({
      id: item.id,
      title: item.title,
      sku: item.sku,
      quantity: item.quantity,
      price: item.price,
      lineTotal: item.price * item.quantity,
    })),
    subtotal,
    shippingCost: subtotal >= 99 ? 0 : 20,
    total: subtotal + (subtotal >= 99 ? 0 : 20),
    status: "Confirmed",
  };
};

export const generateAdminEmailPayload = (order) => {
  const itemsText = order.items
    .map((i) => `  • ${i.title} (SKU: ${i.sku}) × ${i.quantity} = ${formatCurrency(i.lineTotal)}`)
    .join("\n");

  const subject = `New Order Received — ${order.orderId}`;

  const body = `
=== NEW ORDER NOTIFICATION ===
Order #: ${order.orderId}
Date: ${order.orderDateFormatted}
Status: ${order.status}

--- CUSTOMER ---
Name: ${order.customer.firstName} ${order.customer.lastName}
Email: ${order.customer.email}
Phone: ${order.customer.phone || "N/A"}

--- ITEMS ORDERED ---
${itemsText}

Subtotal: ${formatCurrency(order.subtotal)}
Shipping: ${order.shippingCost === 0 ? "FREE" : formatCurrency(order.shippingCost)}
TOTAL: ${formatCurrency(order.total)}

--- SHIPPING ADDRESS ---
${order.shippingAddress.address}
${order.shippingAddress.city}, ${order.shippingAddress.state} ${order.shippingAddress.zip}
${order.shippingAddress.country}

--- BILLING ADDRESS ---
${order.billing.address}
${order.billing.city}, ${order.billing.state} ${order.billing.zip}
${order.billing.country}

--- PAYMENT ---
Method: ${order.payment.method}
Cardholder: ${order.payment.cardholderName}
Card: ${order.payment.maskedCard}
Expiry: ${order.payment.expiry}

================================
StoreOnline — TS ELITE SOURCE LLC Admin Notification
`;

  return { subject, body: body.trim(), to: "info@e-storeonline.online" };
};

export const buildMailtoLink = (emailPayload) => {
  const params = new URLSearchParams({
    subject: emailPayload.subject,
    body: emailPayload.body,
  });
  return `mailto:${emailPayload.to}?${params.toString()}`;
};
